@import '../../../../constants/spacing.module.less';

.header-pills-container {
  justify-content: flex-start;
  margin-left: @space-8;
}
